import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Grid,
  Paper,
  Typography,
  Box,
  Card,
  Table,
  TableCell,
  TableRow,
  Button,
  Divider,
} from "@mui/material";
import {
  START_CHASEUP_CHART,
  START_GET_HOME_LIST,
  START_GET_NO_OF_ALERT,
  START_ORDER_CHART,
} from "Actions/HomeAction";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import { dashboardWidget, newHomeList } from "utils/data";
import HomeLoader from "Components/Common/HomeLoader";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import BarChart from "Components/Common/BarChart";
import { getLocalStorage, setLocalStorage } from "utils/generalUtils";
import { START_GET_COLLECTION_LIST } from "Actions/CollectionAction";
import LineChart from "Components/Common/LineChart";
import PieChart from "Components/Common/PieChart";
import { START_ORDER_SPEED } from "Actions/OrderPadAction";
import { useSelector } from "react-redux";
import CardDashbord from "Components/Common/CardDashbord";
import "../../Sass/Dashboard.scss";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import BillingDialog from "../Common/BillingDialog";
import { START_GET_REPEAT_ORDER_LIST } from "Actions/RepeatOrderAction";
import { ReactComponent as ArrowNext } from "Assets/Icons/DashboardIcons/ArrowNext.svg";
import { ReactComponent as DollarHand } from "Assets/Icons/DashboardIcons/DollarHand.svg";
import { ReactComponent as QuestionMark } from "Assets/Icons/DashboardIcons/QuestionMark.svg";
import { ReactComponent as MissMatchIcon } from "Assets/Icons/DashboardIcons/MissMatchIcon.svg";
import { ReactComponent as WarningIcon } from "Assets/Icons/PharmsmartIcon/WarningIcon.svg";
import { ReactComponent as WarningIconRed } from "Assets/Icons/DashboardIcons/WarningIconRed.svg";

import useViewport from "Hooks/useViewport";
const useStyle = makeStyles((theme) => ({
  rsHomePaper: {
    width: "100%",
    height: "152px",
    borderRadius: "16px !important",
    background: "#fff !important",
    cursor: "pointer !important",
    // borderRadius: "12px",
    boxShadow: "rgba(149, 157, 165, 0.2) 0px 5px 15px 0px !important",

    [theme.breakpoints.down("sm")]: {
      width: "238px",
    },
    [theme.breakpoints.up("xs")]: {
      width: "100% !important",
    },
    "&:hover": {
      // boxShadow: "8px 4px 11px rgba(38, 94, 172, 0.16) !important",
    },
    "&>div": {
      // padding: "22px 19px",
      "&>h2": {
        fontSize: "35px",
      },
      "&>svg": {
        marginBottom: "-28px",
        marginLeft: "30px",
      },
    },
    "&>h4": {
      fontSize: "18px !important",
      marginLeft: "23px",
      color: theme.palette.background.black,
    },
  },
  rsChild: {
    fontSize: "12px",
    textAlign: "right",
    marginRight: "11px",
    marginTop: "-26px",
    [theme.breakpoints.down(1400)]: {
      fontSize: "9px",
    },
  },
  rsMainGrid: {
    "&:nth-child(even)": {
      [theme.breakpoints.between("600", "770")]: {
        paddingRight: "10px !important",
      },
    },
    "&:nth-child(odd)": {
      [theme.breakpoints.between("600", "770")]: {
        paddingLeft: "20px !important",
      },
    },
    [theme.breakpoints.down("600")]: {
      margin: "0 auto !important",
      paddingLeft: "25px !important",
      paddingRight: "10px !important",
    },
    [theme.breakpoints.down("600")]: {
      margin: "0 auto !important",
      paddingLeft: "20px !important",
      paddingRight: "10px !important",
    },
  },
  rsOrderSpeed: {
    background: "white",
    // height: "400px ",
    height: "100%",
    // marginLeft: "20px",
    // marginTop: "20px",
    borderRadius: "15px",
    width: "100% !important",
    "&>h4": {
      paddingLeft: "10px",
      paddingTop: "10px",
      marginBottom: "20px",
      fontSize: "1.5rem !important",
      fontWeight: "500 !important",
      color: "#000000 !important",
    },
    "&>div": {
      paddingLeft: "20px",
      paddingRight: "20px",
      "&>canvas": {
        width: "100% !important",
      },
    },
  },
  rsChaseup: {
    background: "rgba(90,104,114,0.05)",
    height: "100%",
    borderRadius: "10px",
    // marginLeft: "20px",
    marginTop: "20px",
    width: "100% !important",
    "&>h4": {
      paddingLeft: "10px",
      paddingTop: "10px",
      fontSize: "20px !important",
      color: "#000000 !important",
    },
    "&>div": {
      paddingLeft: "20px",
      paddingRight: "20px",
      "&>canvas": {
        height: "182px",
        width: "100% !important",
      },
    },
  },
  rsOrders: {
    background: "rgba(90,104,114,0.05)",
    height: "100%",
    borderRadius: "10px",
    // marginLeft: "20px",
    marginTop: "20px",
    paddingBottom: "20px",
    width: "100% !important",
    "&>h4": {
      paddingLeft: "10px",
      paddingTop: "10px",
      fontSize: "20px !important",
      color: "#000000 !important",
    },
    "&>div": {
      paddingLeft: "20px",
      paddingRight: "20px",
      "&>canvas": {
        height: "100% !important",
        width: "100% !important",
      },
    },
  },
  luMobile: {
    [theme.breakpoints.down(769)]: {
      paddingLeft: "20px !important",
      paddingRight: "20px !important",
    },
  },
  luMobileC: {
    [theme.breakpoints.down(769)]: {
      paddingLeft: "5px !important",
      paddingRight: "5px !important",
    },
  },
  rsFontSize: {
    "&>h3": {
      fontSize: "20px !important",
    },
  },
  rsOverallScroe: {
    height: "80px !important",
    "&>h3": {
      fontWeight: "500 !important",
    },
  },
  rsLeaderboader: {
    border: "3 solid",
    fontSize: "10px !important",
    marginLeft: "3px !important",
    marginRight: "3px",
    marginTop: "30px",
    marginBottom: "30px",
    color: "#7BC044",
    background: "#7BC044",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingRight: "20px",
    height: "250px !important",
    "&>div": {
      width: "96%",
      "&>h3": {
        textAlign: "center",
        fontWeight: "500 !important",
        paddingTop: "0px !important",
        paddingBottom: "10px !important",
      },
      "&>table": {
        "&>tr": {
          "&>td": {
            border: "solid",
            borderWidth: "1px",
          },
        },
      },
    },
  },
  rsMainChart: {
    display: "flex",
    justifyContent: "space-around",
  },
  rsGettingStarted: {
    marginTop: "40px",
    background: "white",
    // border: "2px",
    // borderColor: "black",
    // borderStyle: "solid",
    borderRadius: "5px",
    width: "40%",
    height: "fit-content",
    paddingBottom: "15px",
    display: "inline-block",
    justifyContent: "start",
    "&>h2": {
      paddingLeft: "20px",
      fontSize: "30px",
      fontWeight: "500",
      color: "black",
      textAlign: "start",
      justifyContent: "center",
    },
    [theme.breakpoints.down(1600)]: {
      width: "50%",
    },
    [theme.breakpoints.down(1300)]: {
      width: "60%",
    },
    [theme.breakpoints.down(1100)]: {
      width: "80%",
    },
    [theme.breakpoints.down(900)]: {
      width: "90%",
    },
    [theme.breakpoints.down(786)]: {
      width: "97%",
      marginLeft: "10px",
    },
  },
  titlesetting: {
    background: "#7bbd4b !important",
    padding: "10px",
    borderRadius: "5px 5px 0px 0px",
    "&>h2": {
      fontSize: "20px",
      fontWeight: "500 !important",
      color: "white !important",
    },
  },
  rsRowColor: {
    borderRadius: "10px",
    backgroundColor: "rgba(171, 214, 167, 1)",
    display: "flex",
    padding: "10px",
    paddingLeft: "30px",
    margin: "10px",
    paddingRight: "30px",
    justifyContent: "space-between",
    alignItems: "center",
    "&>button": {
      borderRadius: "10px",
      height: "40px",
      whiteSpace: "nowrap",
      backgroundColor: "rgba(233, 248, 229, 1) !important",
      color: "black",
      width: "160px",
      fontWeight: "400 !important",
    },
    "&>h3": {
      fontSize: "22px",
      fontWeight: "400",
      color: "black",
      // textAlign: "center",
      // justifyContent: "center",
    },
    [theme.breakpoints.down(500)]: {
      display: "block",
    },
  },
  GettingBoxMain: {
    display: "flex",
    justifyContent: "start",
  },
  rsMainMarign: {
    [theme.breakpoints.down(768)]: {
      marginTop: "30px !important",
    },
  },
  RsGridBox: {
    background: "#000",
  },
  rsRowMain: {
    background: "#fff",
    border: "solid 1px #dddddd",
    borderRadius: "4px",
    marginTop: "10px",
    padding: "10px 14px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "10px",
    marginRight: "10px",
    "&>h5": {
      fontWeight: "500 !important",
      fontSize: "18px !important",
      color: "black",
    },
  },
  iconHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "15px",
    paddingLeft: "15px",
    paddingTop: "15px",
    paddingBottom: "10px",

    "&>div:nth-child(2)": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "&:hover": {
        cursor: "pointer",
        "& h4": {
          color: "rgba(90, 104, 114, 1) !important",
        },
        "& svg > path": {
          fill: "rgba(90, 104, 114, 1) !important",
        },
      },
      "&>h4": {
        color: "black",
        marginRight: "5px",
        fontWeight: "400",
        textAlign: "center",
        marginTop: "-25px",
        [theme.breakpoints.between("1415", "1545")]: {
          fontSize: "0.875rem !important",
        },
        [theme.breakpoints.between("1200", "1415")]: {
          fontSize: "0.8rem !important",
        },
      },
      "&>svg": {
        height: "18px",
        width: "18px",
        marginTop: "-25px",
        "&>path": {
          fill: "black",
        },
      },
    },
  },

  titleHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingRight: "15px",
    paddingLeft: "15px",
    "&>div": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "flex-end",
      width: "100%",
      "&>h2": {
        color: "black",
        marginRight: "10px",
        fontWeight: "600",
      },
      "&>h4": {
        color: "#5A6872 !important",
        marginBottom: "8px",
        fontWeight: "400",
      },
    },
    "&>h4": {
      color: "black",
      fontWeight: "600",
      fontSize: "1.125rem !important",
      marginTop: "-7px",
    },
  },

  mainHeading: {
    marginBottom: "5px !important",
    color: "black !important",
    fontWeight: "500 !important",
    marginTop: "10px !important",
  },
  mainHeadingOverview: {
    marginBottom: "5px !important",
    color: "black !important",
    fontWeight: "500 !important",
    // marginTop: "25px !important",
    marginTop: "15px !important",
  },
  warningMain: {
    // height: "257px",
    // width:"579px",
    marginRight: "24px !important",
    marginLeft: "24px !important",
    // marginTop: "40px !important",
    marginTop: "28px !important",
    [theme.breakpoints.down(900)]: {
      marginRight: "0px !important",
      marginLeft: "10px !important",
      marginTop: "28px !important",
    },
  },
  warningPaper: {
    height: "100%",
    borderRadius: "15px !important",
  },
  graphMain: {
    // height: "423px",
    // marginTop: "40px !important",
    // width:"579px",
    // marginRight:"24px !important"
    height: "400px",
    marginTop: "28px !important",
  },
  warningPaperHeading: {
    display: "flex",
    flexDirection: "column",
    "&>div": {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "&>h2:nth-child(1)": {
        marginLeft: "15px",
        marginRight: "10px",
        marginTop: "8px",
        marginBottom: "8px",
        fontSize: "1.25rem",
        fontWeight: "500",
        color: "black",
      },
      "&>h2:nth-child(2)": {
        fontSize: "1.25rem",
        fontWeight: "700",
        color: "black",
      },
    },
    "&>div:nth-child(2)": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
      "&>hr": {
        width: "96%",
        background: "rgba(80, 80, 80, 0.6)",
      },
    },
  },
  warningSubMain: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "15px",
  },
  warningSub: {
    width: "96%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
    "&>div": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      "&>h5": {
        fontWeight: "400",
        fontSize: "1.125rem !important",
        color: "black",
        marginLeft: "10px",
        [theme.breakpoints.down("430")]: {
          fontSize: "1rem !important",
        },
        [theme.breakpoints.down("380")]: {
          fontSize: "0.85rem !important",
        },
        [theme.breakpoints.down("330")]: {
          marginLeft: "7px",
        },
      },
      "&>svg": {
        [theme.breakpoints.down("430")]: {
          width: "25px",
          height: "25px",
        },
        [theme.breakpoints.down("380")]: {
          width: "20px",
          height: "20px",
        },
      },
      "&>svg:nth-child(3)": {
        marginLeft: "30px !important",
        [theme.breakpoints.down("450")]: {
          marginLeft: "10px !important",
        },
      },
    },
    "&>h5": {
      fontWeight: "600",
      fontSize: "1.125rem !important",
      color: "black",
      textDecoration: "underline",
      cursor: "pointer",
      "&:hover": {
        color: "rgba(90, 104, 114, 0.9) !important",
        cursor: "pointer",
      },
      [theme.breakpoints.down("430")]: {
        fontSize: "1rem !important",
      },
      [theme.breakpoints.down("380")]: {
        fontSize: "0.85rem !important",
      },
    },
  },
  dashboardContainer: {
    marginTop: "0px !important",
  },
}));

const HomeMain = (props) => {
  const classes = useStyle();
  const navigate = useNavigate();
  const {
    getHomeListAction,
    homeList,
    setCheckedChaseUp,
    getCollectionRxAction,
    orderSpeed,
    getOrderSpeedAction,
    getChaseupChartAction,
    chaseupChart,
    getOrderChartAction,
    orderChart,
    getOrderListAction,
    noOfAlertData,
    getNoOfAlertAction,
  } = props;
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const userRole = getLocalStorage("role");
  const [orderSpeedCount, setOrderSpeedCount] = useState([]);
  const [orderSpeedDay, setOrderSpeedDay] = useState([]);
  const [chaseUpCount, setChaseUpCount] = useState([]);
  const [chaseUpDay, setChaseUpDay] = useState([]);
  const [chaseUpCollection, setChaseUpCollection] = useState([]);
  const [uncollectionValue, setUncollectionValue] = useState([]);
  const [allOrder, setAllOrder] = useState("");
  const [todayOrder, setTodayOrder] = useState("");
  const [lowOrder, setLowOrder] = useState("");
  const [highOrder, setHighOrder] = useState("");
  const [isHovered, setIsHovered] = React.useState("");
  const [paymentDialog, setPaymentDialog] = useState(false);
  const [orderLable, setorderLable] = useState([
    "Today's orders",
    "Future orders",
  ]);
  const [orderPriority, setorderPriority] = useState([
    "High orders",
    "Low orders",
  ]);
  const [warnings, setWarnings] = useState({
    unssagined: 0,
    missmatch: 0,
    subscription: "",
    order_gap: {
      high_order_gap: 0,
      low_order_gap: 0,
    },
  });
  const [warningCount, setWarningCount] = useState(0);
  const [numberPart, setNumberPart] = useState(0);
  const [unitPart, setUnitPart] = useState("days");
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const loginUserDetail = useSelector((state) => state.user);
  const showDataBasedOnRole =
    loginUserDetail?.loginUserDetail?.data?.data?.role;
  let expireLimit = 31;
  let newObject = {};
  const handleMouseEnter = (item) => {
    setIsHovered(item);
  };

  const handleMouseLeave = () => {
    setIsHovered("");
  };
  let { width } = useViewport();
  if (loginUserDetail?.loginUserDetail?.data?.data?.is_applied_payment) {
    if (
      loginUserDetail?.loginUserDetail?.data?.data?.is_trial &&
      loginUserDetail?.loginUserDetail?.data?.data?.role != "super_admin" &&
      loginUserDetail?.loginUserDetail?.data?.data?.is_new_user &&
      unitPart === "days"
    ) {
      if (!loginUserDetail?.loginUserDetail?.data?.data?.is_expired) {
        newObject = {
          count: 0,
          key: "payment",
          label: `Trial:  ${loginUserDetail?.loginUserDetail?.data?.data?.day_diff} left `,
        };
      } else {
        newObject = {
          count: 0,
          key: "payment",
          label: `Trial: expired`,
        };
      }
    }
    if (
      !loginUserDetail?.loginUserDetail?.data?.data?.is_trial &&
      loginUserDetail?.loginUserDetail?.data?.data?.is_new_user &&
      loginUserDetail?.loginUserDetail?.data?.data?.role != "super_admin" &&
      loginUserDetail?.loginUserDetail?.data?.data?.role != "admin" &&
      !loginUserDetail?.loginUserDetail?.data?.data?.is_expired
    ) {
      if (expireLimit < numberPart) {
        newObject = {
          count: 0,
          key: "payment",
          label: `${loginUserDetail?.loginUserDetail?.data?.data?.day_diff} remaining `,
        };
      } else {
        newObject = {
          count: 0,
          key: "payment",
          label: `Your subscription renews after ${loginUserDetail?.loginUserDetail?.data?.data?.day_diff}`,
          // label: `${loginUserDetail?.loginUserDetail?.data?.data?.day_diff}  until subscription expires `,
        };
      }
    }
    if (
      !loginUserDetail?.loginUserDetail?.data?.data?.is_trial &&
      loginUserDetail?.loginUserDetail?.data?.data?.role != "super_admin" &&
      loginUserDetail?.loginUserDetail?.data?.data?.is_expired
    ) {
      newObject = {
        count: 0,
        key: "payment",
        label: ` Subscription expired!`,
      };
    }
  }

  useEffect(() => {
    let payloadHome = {};
    if (
      selectedHeaderPharmacyId !== "" &&
      selectedHeaderPharmacyId !== undefined &&
      selectedHeaderPharmacyId !== "all" &&
      selectedHeaderPharmacyId !== null
    ) {
      payloadHome = {
        pharmacy_id: [selectedHeaderPharmacyId],
      };

      getNoOfAlertAction(payloadHome);
    } else {
      getNoOfAlertAction();
    }
  }, []);
  // useEffect(() => {
  //   return () => {
  //     if (window.location.pathname !== "/home") {
  //       let payLoad = {};
  //       if (
  //         selectedHeaderPharmacyId !== "" &&
  //         selectedHeaderPharmacyId !== "all" &&
  //         selectedHeaderPharmacyId !== undefined &&
  //         selectedHeaderPharmacyId !== null
  //       ) {
  //         payLoad = {
  //           pharmacy_id: [selectedHeaderPharmacyId],
  //         };
  //         getHomeListAction(payLoad);
  //         // getOrderSpeedAction(payLoad);
  //         // getChaseupChartAction(payLoad);
  //         // getOrderChartAction(payLoad);
  //       } else {
  //         getHomeListAction();
  //         // getOrderSpeedAction();
  //         // getChaseupChartAction();
  //         // getOrderChartAction();
  //       }
  //       window.onbeforeunload = null;
  //       setLocalStorage("pharmacyChange", false);
  //     }
  //   };
  // }, []);

  useEffect(() => {
    let payLoad = {};
    if (
      selectedHeaderPharmacyId !== "" &&
      selectedHeaderPharmacyId !== "all" &&
      selectedHeaderPharmacyId !== undefined &&
      selectedHeaderPharmacyId !== null
    ) {
      payLoad = {
        pharmacy_id: [selectedHeaderPharmacyId],
      };
      getHomeListAction(payLoad);
    } else {
      getHomeListAction();
    }
    setLocalStorage("pharmacyChange", false);
  }, []);

  useEffect(() => {
    if (orderSpeed?.loading === false) {
      let tempDay = [];
      let tempCount = [];
      orderSpeed?.data?.data?.map((item, index) => {
        tempDay.push(item.day);
        tempCount.push(item?.count);
      });
      setOrderSpeedDay(tempDay);
      setOrderSpeedCount(tempCount);
    }
  }, [orderSpeed]);
  useEffect(() => {
    if (chaseupChart?.loading === false) {
      let tempDay = [];
      let tempCount = [];
      let tempCollection = [];
      let tempUncollection = [];
      chaseupChart?.data?.data?.map((item, index) => {
        tempDay.push(item.day);
        tempCount.push(item?.chaseup_count);
        tempCollection.push(item?.collection_count);
        tempUncollection.push(item?.un_collection_count);
      });
      setChaseUpDay(tempDay);
      setChaseUpCount(tempCount);
      setUncollectionValue(tempUncollection);
      setChaseUpCollection(tempCollection);
    }
  }, [chaseupChart]);
  useEffect(() => {
    if (orderChart?.loading === false) {
      let tempDay = [];
      let tempCount = [];
      let tempCollection = [];
      orderChart?.data?.data?.map((item, index) => {
        if (item?.key === "order_list") {
          item?.child?.map((value) => {
            if (value?.key === "all_order") {
              setAllOrder(value?.count);
            } else {
              setTodayOrder(value?.count);
            }
          });
        }
        if (item?.key === "order_gap") {
          item?.child?.map((value) => {
            if (value?.key === "high_order_gap") {
              setHighOrder(value?.count);
            } else {
              setLowOrder(value?.count);
            }
          });
        }
        // tempDay.push(item.day);
        // tempCount.push(item?.chaseup_count);
        // tempCollection.push(item?.collection_count);
      });
      // setChaseUpDay(tempDay);
      // setChaseUpCount(tempCount);
      // setChaseUpCollection(tempCollection);
    }
  }, [orderChart]);
  /* Pharmacy Header filter with home api calling useEffect */
  useEffect(() => {
    let payLoad = {};
    if (!homeList?.loading) {
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all" &&
        selectedHeaderPharmacyId !== undefined &&
        selectedHeaderPharmacyId !== null
      ) {
        payLoad = {
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        getHomeListAction(payLoad);
        // getOrderSpeedAction(payLoad);
        // getChaseupChartAction(payLoad);
        // getOrderChartAction(payLoad);
      } else if (getLocalStorage("pharmacyChange") == "true") {
        getHomeListAction();
        // getOrderSpeedAction();
        // getChaseupChartAction();
        // getOrderChartAction();
      }
    }
  }, [selectedHeaderPharmacyId]);

  var barChartData = {
    labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "TODAY"],
    datasets: [
      {
        label: "Orders",
        backgroundColor: "rgba(123, 192, 68, 1)",
        borderColor: "rgba(123, 192, 68, 1)",
        borderWidth: 1,
        data: [3, 5, 6, 7, 3, 5, 6],
        barThickness: 18,
      },
      {
        label: "Chase Ups",
        backgroundColor: "#2b5c05",
        borderColor: "#2b5c05",
        borderWidth: 1,
        data: [4, 7, 3, 6, 10, 7, 4],
        barThickness: 18,
      },
    ],
  };
  var chartOptions = {
    responsive: true,
    clip: true,
    categoryPercentage: 1,
    barPercentage: 1,
    indexAxis: "x",
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          boxHeight: 20,
          padding: 10,
          color: "black",
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          // offset: false,
        },
        // offset: false,
        min: 0,
        max: 7,
        ticks: {
          color: "black",
          beginAtZero: true,
          // maxTicksLimit: 14,
          padding: 10,
          display: "flex",
        },
      },
      y: {
        min: 0,
        max: 10,
        ticks: {
          stepSize: 2,
          color: "black",
          beginAtZero: true,
        },
      },
    },
  };
  // Warning Dialog useEffect
  useEffect(() => {
    if (noOfAlertData?.data?.data && noOfAlertData?.data?.data.length > 0) {
      noOfAlertData?.data?.data?.map((item) => {
        if (item && item.key === "miss_match") {
          setWarnings((prev) => ({
            ...prev,
            missmatch: item.count,
          }));
        } else if (item && item.key === "unassigned") {
          setWarnings((prev) => ({
            ...prev,
            unssagined: item.count,
          }));
        }
      });
    } else {
      setWarnings((prev) => ({
        ...prev,
        unssagined: 0,
        missmatch: 0,
      }));
    }
    if (loginUserDetail?.loginUserDetail?.data?.data) {
      setWarnings((prev) => ({
        ...prev,
        subscription: newObject.label,
      }));
    }
    homeList?.data?.data?.map((i) => {
      if (i.key === "order_gap") {
        setWarnings((prev) => ({
          ...prev,
          order_gap: {
            high_order_gap: i.child[0].count,
            low_order_gap: i.child[1].count,
          },
        }));
      }
    });
  }, [noOfAlertData, loginUserDetail?.loginUserDetail?.data?.data, homeList]);

  useEffect(() => {
    // const nonEmptyValues = Object.values(warnings).filter(
    //   (value) =>
    //     value !== "" && value !== 0 && value !== undefined && value !== null
    // );
    if (
      (homeList.loading === false && homeList?.data?.data) ||
      (loginUserDetail?.loginUserDetail.loading === false &&
        loginUserDetail?.loginUserDetail?.data?.data) ||
      (noOfAlertData?.loading === false &&
        noOfAlertData?.data?.data?.success === true)
    ) {
      const nonEmptyValues = Object.entries(warnings).filter(([key, value]) => {
        if (key === "order_gap") {
          return value.high_order_gap !== 0 || value.low_order_gap !== 0;
        }
        return (
          value !== "" && value !== 0 && value !== undefined && value !== null
        );
      });
      if (nonEmptyValues && nonEmptyValues.length > 0) {
        setWarningCount(nonEmptyValues.length);
      } else {
        setWarningCount(0);
      }
    }
  }, [
    warnings,
    noOfAlertData,
    loginUserDetail?.loginUserDetail?.data?.data,
    homeList,
  ]);

  useEffect(() => {
    if (loginUserDetail?.loginUserDetail?.data?.data?.day_diff) {
      const trimmedString =
        loginUserDetail?.loginUserDetail?.data?.data?.day_diff.trim();
      const parts = trimmedString?.split(" ");
      setNumberPart(parts[0]);
      setUnitPart(parts[1]);
    }
  }, [loginUserDetail?.loginUserDetail?.data?.data]);

  let getNavLabel = (item) => {
    let label = newHomeList.map((newItem) => {
      if (newItem.key === item.key) {
        return newItem.navLabel;
      }
    });
    return label;
  };

  return (
    <>
      {/*   Today HEADING    */}
      {/* {!homeList?.loading && (
        <Typography variant="h3" className={classes.mainHeading}>
          Today
        </Typography>
      )} */}
      <Grid
        container
        spacing={{ xs: 2, sm: 1, md: 3, lg: 3 }}
        columns={{ xs: 1, sm: 4, md: 20, lg: 20 }}
        className={classes.dashboardContainer}
      >
        {homeList?.loading ? (
          <HomeLoader
            rows={
              ["admin", "super_admin"].indexOf(userRole) !== -1 ? 8 : 8
              //  ["pharmacist_staff", "pharmacist", "pharmacy"].indexOf(
              //     userRole
              //   ) !== -1
              // ? 7
              // : 4
            }
          />
        ) : (
          homeList?.data?.data?.map((item, index) => {
            return (
              <>
                {/* {["pharmacies_list", "staff_list", "Collected_list"].indexOf( */}
                {["pharmacies_list", "staff_list", "Collected_list"].indexOf(
                  item.key
                ) === -1 && (
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    md={width < 1130 ? 10 : 6.6}
                    // lg={6.6}
                    lg={
                      width < 1300 && width > 1230
                        ? 6.65
                        : width < 1230
                        ? 6.66
                        : 5
                    }
                    key={index}
                    className={classes.rsMainGrid}
                  >
                    <Paper
                      className={classes.rsHomePaper}
                      style={{
                        backgroundColor: dashboardWidget[item.key].background,
                      }}
                      onClick={() => {
                        if (
                          item?.key == "oos_list" &&
                          selectedHeaderPharmacyId === "all"
                        ) {
                          let payload = {
                            offset: 0,
                            limit: 20,
                            type: "all",
                            is_oos: true,
                          };
                          // setLocalStorage("oos_filter", "true");
                          navigate(`/order?oos=true`);
                          // getOrderListAction(payload);
                        } else if (
                          item?.key == "oos_list" &&
                          selectedHeaderPharmacyId !== "all"
                        ) {
                          if (showDataBasedOnRole == "admin") {
                            // setLocalStorage("oos_filter", "true");
                            navigate(`/order?oos=true`);
                          } else {
                            let payload = {
                              offset: 0,
                              limit: 20,
                              type: "all",
                              is_oos: true,
                            };
                            // setLocalStorage("oos_filter", "true");
                            navigate(`/order?oos=true`);
                            // getOrderListAction(payload);
                          }
                        }
                        if (item?.key !== "oos_list") {
                          navigate(`/${dashboardWidget[item.key].link}`);
                        }
                        if (dashboardWidget[item.key].chaseUp) {
                          let payload = {
                            offset: 0,
                            is_chase_up: true,
                            type: "un_collected",
                            limit: 20,
                          };
                          setCheckedChaseUp(true);
                          if (
                            getLocalStorage("urlcollection") == "none" &&
                            selectedHeaderPharmacyId === "all"
                          ) {
                            // getCollectionRxAction(payload);
                          }
                        } else {
                          setCheckedChaseUp(false);
                          let payload = {
                            offset: 0,
                            is_chase_up: false,
                            type: "un_collected",
                            limit: 20,
                          };
                          if (
                            dashboardWidget?.uncollected_list?.setCollection ===
                              "un_collected" &&
                            getLocalStorage("urlcollection") == "none" &&
                            selectedHeaderPharmacyId === "all"
                          ) {
                            // getCollectionRxAction(payload);
                          }
                        }
                      }}
                    >
                      <Box className={classes.iconHeader}>
                        <Box
                          className={
                            item.key === "chase_up" ||
                            item.key === "order_list" ||
                            item.key === "uncollected_list" ||
                            item.key === "patient_list"
                              ? "RsGridBoxNew"
                              : "RsGridBox"
                          }
                          style={{
                            backgroundColor:
                              isHovered === index
                                ? dashboardWidget[item.key].boxColor
                                : dashboardWidget[item.key].BackgroundBoxColor,
                            transition: "background-color 0.3s, color 0.3s",
                          }}
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={handleMouseLeave}
                        >
                          <PrimaryIcon
                            icon={dashboardWidget[item.key]?.icon}
                            cursor="pointer"
                          />
                        </Box>
                        <Box>
                          <Typography variant="h4">
                            {getNavLabel(item)}
                          </Typography>
                          <PrimaryIcon icon={ArrowNext} cursor="pointer" />
                        </Box>
                      </Box>

                      <Box className={classes.titleHeader}>
                        <Box>
                          <Typography variant="h2">{item?.count}</Typography>
                          {/* <Typography variant="h4">
                            {item?.todayLabel}
                          </Typography> */}
                        </Box>
                        <Typography variant="h4">
                          {item?.label}
                          <br />

                          {/*  HIGH/LOW ORDER GAP CHILDREN  */}

                          {/* {item?.child && (
                            <Box className={classes.rsChild}>
                              {item?.child[0]?.label}: {item?.child[0]?.count}{" "}
                              <br />
                              {item?.child[1]?.label} : {item?.child[1]?.count}
                            </Box>
                          )} */}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                )}
              </>
            );
          })
        )}
        {!homeList?.loading && warningCount > 0 && (
          <Grid xs={12} sm={12} md={12} lg={12} xl={12} container>
            <Grid
              item
              xs={12}
              sm={12}
              md={
                width < 1200 && width >= 1130
                  ? 7
                  : width < 1130 && width >= 1065
                  ? 8
                  : width < 1065
                  ? 10
                  : 7
              }
              lg={width < 1450 && width >= 1260 ? 6 : width < 1260 ? 7 : 5}
              xl={5}
              className={classes.warningMain}
            >
              <Paper className={classes.warningPaper}>
                <Box className={classes.warningPaperHeading}>
                  <Box>
                    <Typography variant="h2">Warnings</Typography>
                    <Typography variant="h2">({warningCount})</Typography>
                  </Box>
                  <Box>
                    <Divider />
                  </Box>
                </Box>

                <Box className={classes.warningSubMain}>
                  {Object.keys(newObject)?.length > 0 && (
                    <Box className={classes.warningSub}>
                      <Box>
                        <PrimaryIcon icon={DollarHand} />
                        <Typography variant="h5">
                          {warnings.subscription}
                        </Typography>
                      </Box>
                      <Typography
                        variant="h5"
                        onClick={() => {
                          setPaymentDialog(true);
                        }}
                      >
                        Fix Now
                      </Typography>
                    </Box>
                  )}

                  {warnings?.unssagined > 0 && (
                    <Box className={classes.warningSub}>
                      <Box>
                        <PrimaryIcon icon={QuestionMark} />
                        <Typography variant="h5">
                          {warnings.unssagined || "0"} unassigned orders
                        </Typography>
                      </Box>
                      <Typography
                        variant="h5"
                        onClick={() => {
                          navigate("/order?unassigned=true");
                        }}
                      >
                        Fix Now
                      </Typography>
                    </Box>
                  )}

                  {(warnings?.order_gap.high_order_gap > 0 ||
                    warnings?.order_gap.low_order_gap > 0) && (
                    <Box className={classes.warningSub}>
                      <Box>
                        <PrimaryIcon color={"red"} icon={WarningIconRed} />
                        <Typography variant="h5">
                          {warnings.order_gap.high_order_gap} order issues
                        </Typography>
                        <PrimaryIcon
                          icon={WarningIcon}
                          width={32}
                          height={32}
                        />
                        <Typography variant="h5">
                          {warnings.order_gap.low_order_gap} order issues
                        </Typography>
                      </Box>
                      <Typography
                        variant="h5"
                        onClick={() => {
                          navigate(`/order?warnings=true`);
                        }}
                      >
                        Fix Now
                      </Typography>
                    </Box>
                  )}

                  {warnings.missmatch > 0 && (
                    <Box className={classes.warningSub}>
                      <Box>
                        <PrimaryIcon icon={MissMatchIcon} />
                        <Typography variant="h5">
                          {warnings.missmatch || "0"} mismatched order dates
                        </Typography>
                      </Box>
                      <Typography
                        variant="h5"
                        onClick={() => {
                          navigate("/order?orderDateMissmatch=true");
                        }}
                      >
                        Fix Now
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        )}
        {/* {showDataBasedOnRole !== "user" && (
        <Grid item xs={10} className={classes.luMobile}>
          <Box className={classes.rsOrderSpeed}>
            <Typography variant="h4"> Order Speed</Typography>
            <BarChart
              labels={orderSpeedDay}
              chartName="Order Speed"
              backgroundColor="rgb(117, 194, 91)"
              borderColor="rgb(117, 194, 91)"
              dataValue={orderSpeedCount}
            />
          </Box>
        </Grid>
      )}
      <Grid item xs={10} className={classes.luMobile}>
        <Box className={classes.rsChaseup}>
          <Typography variant="h4"> Chase Ups</Typography>
          <LineChart
            labels={chaseUpDay}
            chaseupName="Chaseup"
            collectionName="Collection"
            chaseupbackgroundColor="rgb(117, 194, 91)"
            chaseupborderColor="rgba(39, 141, 242, 1)"
            collectionbackgroundColor="rgb(117, 194, 91)"
            collectionborderColor="rgba(222, 98, 98, 1)"
            chaseupValue={chaseUpCount}
            collectionValue={chaseUpCollection}
            uncollectionValue={uncollectionValue}
            uncollectionborderColor="rgb(164, 101, 255)"
            uncollectionName="Uncollection"
          />
        </Box>
      </Grid>

      <Grid item xs={10} className={classes.luMobile}>
        <Typography
          variant="h3"
          style={{ color: "black", paddingTop: "20px", fontWeight: "500" }}
        >
          Need Work
        </Typography>

        <CardDashbord
          color={" rgba(248, 158, 156, 0.6)"}
          variant="filled"
          borderColorChip=" rgba(248, 158, 156, 0.6)"
          textColor="black"
          border="3"
          width="auto"
          icon="😣"
          title="OrderDates are mismatched in 2 cases"
          variantText="h3"
          titleColor="black"
          className={classes.rsFontSize}
        />
        <CardDashbord
          color={"#F6DFDF"}
          variant="filled"
          borderColorChip="#F6DFDF"
          textColor="black"
          border="3"
          width="auto"
          icon="🙁"
          title="Average Collection time 78Hrs"
          variantText="h3"
          titleColor="black"
          className={classes.rsFontSize}
        />
        <CardDashbord
          color={"#EFE5E5"}
          variant="filled"
          borderColorChip="#EFE5E5"
          textColor="black"
          border="3"
          width="auto"
          icon="😕"
          title="Order gap warning: 3red/15 yellow"
          variantText="h3"
          titleColor="black"
          className={classes.rsFontSize}
        />

        <Typography
          variant="h3"
          style={{ color: "black", paddingTop: "20px", fontWeight: "500" }}
        >
          Good Work
        </Typography>
        <CardDashbord
          color={"#C1FF72"}
          variant="filled"
          borderColorChip="#C1FF72"
          textColor="black"
          border="3"
          width="auto"
          icon="🤑"
          title="Order speed average is 35 minutes"
          variantText="h3"
          titleColor="black"
          className={classes.rsFontSize}
        />

        <CardDashbord
          color={"#DBF6B9"}
          variant="filled"
          borderColorChip="#DBF6B9"
          textColor="black"
          border="3"
          width="auto"
          icon="😁"
          title="Out of sync orders:37/223 "
          variantText="h3"
          titleColor="black"
          className={classes.rsFontSize}
        />
        <CardDashbord
          color={"#F2FFE1"}
          variant="filled"
          borderColorChip="#F2FFE1"
          textColor="black"
          border="3"
          width="auto"
          icon="🙂"
          title="Chaseup ration is 33/99"
          variantText="h3"
          titleColor="black"
          className={classes.rsFontSize}
        />
        <CardDashbord
          color={"#D9D9D9"}
          variant="filled"
          borderColorChip="#D9D9D9"
          textColor="black"
          border="3"
          width="auto"
          icon="😐"
          title="Average chaseup time is 26 hrs"
          variantText="h3"
          titleColor="black"
          className={classes.rsFontSize}
        />
      </Grid>

      <Grid item xs={10} className={classes.luMobile}>
        <Box className={classes.rsMainChart}>
          {showDataBasedOnRole !== "user" && (
            <Grid item xs={9.8} className={classes.luMobileC}>
              <Box className={classes.rsOrders}>
                <Typography variant="h4"> Today's Order</Typography>
                <PieChart
                  labels={orderLable}
                  chartName="Today's Order"
                  backgroundColor={[
                    "rgba(6, 199, 227, 1)",
                    "rgba(39, 141, 242, 1)",
                  ]}
                  borderColor={[
                    "rgba(6, 199, 227, 1)",
                    "rgba(39, 141, 242, 1)",
                  ]}
                  dataValue={[todayOrder, allOrder]}
                />
              </Box>
            </Grid>
          )}
          {showDataBasedOnRole !== "user" && (
            <Grid item xs={9.8} className={classes.luMobileC}>
              <Box className={classes.rsOrders}>
                <Typography variant="h4"> Order Gap</Typography>
                <PieChart
                  labels={orderPriority}
                  chartName="Order gap"
                  backgroundColor={[
                    "rgba(6, 199, 227, 1)",
                    "rgba(39, 141, 242, 1)",
                  ]}
                  borderColor={[
                    "rgba(6, 199, 227, 1)",
                    "rgba(39, 141, 242, 1)",
                  ]}
                  dataValue={[highOrder, lowOrder]}
                />
              </Box>
            </Grid>
          )}
        </Box>
        <CardDashbord
          color={"#DBF6B9"}
          variant="filled"
          borderColorChip="#DBF6B9"
          textColor="black"
          border="3"
          width="auto"
          icon="🙂"
          title="Lowwood overall scroll is 28"
          variantText="h3"
          titleColor="black"
          className={classes.rsOverallScroe}
        />
        <Card
          className={classes.rsLeaderboader}
          style={{
            background: "#7BC044",
            borderColor: "#7BC044",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              style={{ color: "black", paddingTop: "20px", fontWeight: "500" }}
            >
              Leaderboard
            </Typography>
            <Table>
              <TableRow>
                <TableCell>7th</TableCell>
                <TableCell>Lowwood</TableCell>
                <TableCell>28</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>7th</TableCell>
                <TableCell>Lowwood</TableCell>
                <TableCell>28</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>7th</TableCell>
                <TableCell>Lowwood</TableCell>
                <TableCell>28</TableCell>
              </TableRow>
            </Table>
          </Box>
        </Card> */}
        {/* </Grid> */}
      </Grid>

      {/*   OVERVIEW HEADING    */}

      {/* {!homeList?.loading && (
        <Typography variant="h3" className={classes.mainHeadingOverview}>
          Overview
        </Typography>
      )} */}

      {/* <Grid
        container
        spacing={{ xs: 2, sm: 1, md: 3, lg: 3 }}
        columns={{ xs: 1, sm: 4, md: 20, lg: 20 }}
      >
        {homeList?.loading ? (
          <HomeLoader
            rows={
              ["admin", "super_admin"].indexOf(userRole) !== -1 ? 3 : 3
            }
          />
        ) : (
          homeList?.data?.data?.slice(3).map((item, index) => {
            return (
              <>
                {["pharmacies_list", "staff_list", "Collected_list"].indexOf(
                  item.key
                ) === -1 && (
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    md={6.6}
                    lg={6.6}
                    // lg={5}
                    key={index + 3}
                    className={classes.rsMainGrid}
                    onClick={() => {
                      if (
                        item?.key == "oos_list" &&
                        selectedHeaderPharmacyId === "all"
                      ) {
                        let payload = {
                          offset: 0,
                          limit: 20,
                          type: "all",
                          is_oos: true,
                        };
                        setLocalStorage("oos_filter", "true");
                        getOrderListAction(payload);
                      } else if (
                        item?.key == "oos_list" &&
                        selectedHeaderPharmacyId !== "all"
                      ) {
                        if (showDataBasedOnRole == "admin") {
                          setLocalStorage("oos_filter", "true");
                        } else {
                          let payload = {
                            offset: 0,
                            limit: 20,
                            type: "all",
                            is_oos: true,
                          };
                          setLocalStorage("oos_filter", "true");
                          getOrderListAction(payload);
                        }
                      }
                      navigate(`/${dashboardWidget[item.key].link}`);
                      if (dashboardWidget[item.key].chaseUp) {
                        let payload = {
                          offset: 0,
                          is_chase_up: true,
                          type: "un_collected",
                          limit: 20,
                        };
                        setCheckedChaseUp(true);
                        if (
                          getLocalStorage("urlcollection") == "none" &&
                          selectedHeaderPharmacyId === "all"
                        ) {
                          getCollectionRxAction(payload);
                        }
                      } else {
                        setCheckedChaseUp(false);
                        let payload = {
                          offset: 0,
                          is_chase_up: false,
                          type: "un_collected",
                          limit: 20,
                        };
                        if (
                          dashboardWidget?.uncollected_list?.setCollection ===
                            "un_collected" &&
                          getLocalStorage("urlcollection") == "none" &&
                          selectedHeaderPharmacyId === "all"
                        ) {
                          getCollectionRxAction(payload);
                        }
                      }
                    }}
                  >
                    <Paper
                      className={classes.rsHomePaper}
                      style={{
                        backgroundColor: dashboardWidget[item.key].background,
                      }}
                    >
                      <Box className={classes.iconHeader}>
                        <Box
                          className="RsGridBox"
                          style={{
                            backgroundColor:
                              isHovered === index + 3
                                ? dashboardWidget[item.key].boxColor
                                : dashboardWidget[item.key].BackgroundBoxColor,
                            transition: "background-color 0.3s, color 0.3s",
                          }}
                          onMouseEnter={() => handleMouseEnter(index + 3)}
                          onMouseLeave={handleMouseLeave}
                        >
                          <PrimaryIcon
                            icon={dashboardWidget[item.key]?.icon}
                            cursor="pointer"
                          />
                        </Box>
                        <Box>
                          <Typography variant="h4">{item?.navLabel}</Typography>
                          <PrimaryIcon icon={ArrowNext} cursor="pointer" />
                        </Box>
                      </Box>

                      <Box className={classes.titleHeader}>
                        <Box>
                          <Typography variant="h2">{item?.count}</Typography>
                          <Typography variant="h4">
                            {item?.todayLabel}
                          </Typography>
                        </Box>
                        <Typography variant="h4">
                          {item?.label}
                          <br />
                          {item?.child && (
                            <Box className={classes.rsChild}>
                              {item?.child[0]?.label}: {item?.child[0]?.count}{" "}
                              <br />
                              {item?.child[1]?.label} : {item?.child[1]?.count}
                            </Box>
                          )}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                )}
              </>
            );
          })
        )}
      </Grid> */}

      {/* </Grid> */}

      {/* PREVIOUS WARNING WIDGET WITH BAR CHART  */}

      {/* {!homeList?.loading && (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} container>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            lg={5.7}
            xl={5.7}
            className={classes.warningMain}
          >
            <Paper className={classes.warningPaper}>
              <Box className={classes.warningPaperHeading}>
                <Box>
                  <Typography variant="h2">Warnings</Typography>
                  <Typography variant="h2">(4)</Typography>
                </Box>
                <Box>
                  <Divider />
                </Box>
              </Box>

              <Box className={classes.warningSubMain}>
                <Box className={classes.warningSub}>
                  <Box>
                    <PrimaryIcon icon={DollarHand} />
                    <Typography variant="h5">
                      Subscription expires in 5 days
                    </Typography>
                  </Box>
                  <Typography variant="h5">Fix Now</Typography>
                </Box>

                <Box className={classes.warningSub}>
                  <Box>
                    <PrimaryIcon icon={QuestionMark} />
                    <Typography variant="h5">21 unassigned orders</Typography>
                  </Box>
                  <Typography
                    variant="h5"
                    onClick={() => {
                      navigate("/order?unassigned=true");
                    }}
                  >
                    Fix Now
                  </Typography>
                </Box>

                <Box className={classes.warningSub}>
                  <Box>
                    <PrimaryIcon color={"red"} icon={WarningIconRed} />
                    <Typography variant="h5">12 order issues</Typography>
                    <PrimaryIcon icon={WarningIcon} width={32} height={32} />
                    <Typography variant="h5">21 order issues</Typography>
                  </Box>
                  <Typography
                    variant="h5"
                    onClick={() => {
                      navigate(`/order`);
                    }}
                  >
                    Fix Now
                  </Typography>
                </Box>

                <Box className={classes.warningSub}>
                  <Box>
                    <PrimaryIcon icon={MissMatchIcon} />
                    <Typography variant="h5">
                      8 mismatched order dates
                    </Typography>
                  </Box>
                  <Typography
                    variant="h5"
                    onClick={() => {
                      navigate("/order?orderDateMissmatch=true");
                    }}
                  >
                    Fix Now
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid> */}

      {/* BAR CHART */}

      {/* <Grid
            item
            xs={6}
            sm={6}
            md={6}
            lg={6}
            xl={6}
            className={classes.graphMain}
          >
            {showDataBasedOnRole !== "user" && (
              <Box className={classes.rsOrderSpeed}>
                <Typography variant="h4">
                  Orders and chase ups in last 7 days
                </Typography>
                <BarChart
                  labels={barChartData.labels}
                  datasets={barChartData.datasets}
                  chartOptions={chartOptions}
                  height={135}
                />
              </Box>
            )}
          </Grid> */}
      {/* </Grid> */}
      {/* )} */}

      {/* <Grid item xs={12} className={classes.GettingBoxMain}>
        <Box className={classes.rsGettingStarted}>
          <Box className={classes.titlesetting}>
            <Typography variant="h2">Getting started</Typography>
          </Box>
          <Box
            className={classes.rsRowMain}
            onClick={() => {
              navigate("/patients");
            }}
          >
            <Typography variant="h5">Import patients from PMR</Typography>
            <PrimaryIcon icon={ChevronRightIcon} />
          </Box>
          <Box
            className={classes.rsRowMain}
            onClick={() => {
              navigate("/how-to");
            }}
          >
            <Typography variant="h5">Watch training videos</Typography>
            <PrimaryIcon icon={ChevronRightIcon} />
          </Box>
          <Box
            className={classes.rsRowMain}
            onClick={() => {
              navigate("/order");
            }}
          >
            <Typography variant="h5">Set up your repeat orders</Typography>
            <PrimaryIcon icon={ChevronRightIcon} />
          </Box>
          <Box className={classes.rsRowColor}>
            <Typography variant="h3">Import patients from PMR</Typography>
            <Button
              variant="contained"
              onClick={() => {
                navigate("/patients?actionType=import-patient");
              }}
            >
              Learn how
            </Button>
          </Box>
          <Box className={classes.rsRowColor}>
            <Typography variant="h3">Watch training videos</Typography>
            <Button
              variant="contained"
              onClick={() => {
                navigate("/how-to");
              }}
            >
              Click here
            </Button>
          </Box>
          <Box className={classes.rsRowColor}>
            <Typography variant="h3">Set up your repeat orders</Typography>
            <Button
              variant="contained"
              onClick={() => {
                navigate("/order");
              }}
            >
              Click here
            </Button>
          </Box>
        </Box>
      </Grid> */}
      {paymentDialog && (
        <BillingDialog open={paymentDialog} setOpen={setPaymentDialog} />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  homeList: state.home.homeList,
  orderSpeed: state.home.orderSpeed,
  chaseupChart: state.home.chaseupChart,
  orderChart: state.home.orderChart,
  noOfAlertData: state.home.noOfAlertData,
});
const mapDispatchToProps = (dispatch) => ({
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  getCollectionRxAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_LIST, payload }),
  getOrderSpeedAction: (payload) =>
    dispatch({ type: START_ORDER_SPEED, payload }),
  getChaseupChartAction: (payload) =>
    dispatch({ type: START_CHASEUP_CHART, payload }),
  getOrderChartAction: (payload) =>
    dispatch({ type: START_ORDER_CHART, payload }),
  getOrderListAction: (payload) =>
    dispatch({ type: START_GET_REPEAT_ORDER_LIST, payload }),
  getNoOfAlertAction: (payload) =>
    dispatch({ type: START_GET_NO_OF_ALERT, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeMain);
